"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var localForage = require("localforage");
var _ = require("lodash");
var redux_1 = require("redux");
var redux_persist_1 = require("redux-persist");
var redux_saga_1 = require("redux-saga");
var effects_1 = require("redux-saga/effects");
var Immutable = require("seamless-immutable");
var articles = require("./articles");
var authentication = require("./authentication");
var books = require("./books");
var environment = require("./environment");
var message = require("./message");
var pages = require("./pages");
var settings = require("./settings");
var tasks = require("./tasks");
var timer = require("./timer");
var videos = require("./videos");
var ducks = {
    articles: articles,
    authentication: authentication,
    books: books,
    environment: environment,
    message: message,
    pages: pages,
    settings: settings,
    tasks: tasks,
    timer: timer,
    videos: videos,
};
function convertImmutableToMutable(immutable) {
    return immutable.asMutable();
}
exports.convertImmutableToMutable = convertImmutableToMutable;
function convertMutableToImmutable(mutable) {
    return Immutable(mutable);
}
exports.convertMutableToImmutable = convertMutableToImmutable;
function default_1() {
    var sagaMiddleware = redux_saga_1.default();
    var store = redux_1.createStore(redux_1.combineReducers(_.mapValues(ducks, function (_a) {
        var reducer = _a.reducer;
        return reducer;
    })), redux_1.compose(redux_1.applyMiddleware(sagaMiddleware), redux_persist_1.autoRehydrate()));
    sagaMiddleware.run(function _() {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, effects_1.all([].concat.apply([], __spread(Object.values(ducks).map(function (_a) {
                        var sagas = _a.sagas;
                        return sagas;
                    }).filter(function (sagas) { return !!sagas; }))))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
    redux_persist_1.persistStore(store, {
        storage: localForage,
        transforms: [redux_persist_1.createTransform(convertImmutableToMutable, convertMutableToImmutable)],
        whitelist: Object.keys(ducks).filter(function (name) { return ducks[name].persistent; }),
    });
    try {
        for (var _a = __values(Object.values(ducks)), _b = _a.next(); !_b.done; _b = _a.next()) {
            var duck = _b.value;
            var storeInitializer = duck.storeInitializer;
            if (storeInitializer) {
                storeInitializer(store);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return store;
    var e_1, _c;
}
exports.default = default_1;



//////////////////
// WEBPACK FOOTER
// ./src/redux/index.ts
// module id = 720
// module chunks = 0